<script lang="ts">
  import Header from "./Header.svelte";
  import LeafletMap from "./LeafletMap.svelte";
  import InfoBox from "./InfoBox.svelte";
  import Notification from "./Notification.svelte";

  let latitude = 0;
  let longitude = 0;
  let message = "";
  let latLonDirection =
    localStorage.getItem("latLonDirection") &&
    localStorage.getItem("latLonDirection") === "false"
      ? false
      : true;

  const moveEndHandler = (evt) => {
    latitude = evt.detail.latlng.lat.toFixed(6);
    longitude = evt.detail.latlng.lng.toFixed(6);
  };

  const clickHandler = (evt) => {
    latitude = evt.detail.latlng.lat.toFixed(6);
    longitude = evt.detail.latlng.lng.toFixed(6);
  };

  const textCopiedHandler = (evt) => {
    message = evt.detail.text;
  };

  const swapButtonClickHandler = () => {
    latLonDirection = !latLonDirection;
    localStorage.setItem("latLonDirection", latLonDirection.toString());
  };
</script>

<main>
  <div class="titleLine">
    <Header />
  </div>
  <div class="mapAreaWrapper">
    <LeafletMap on:moveend={moveEndHandler} on:click={clickHandler} />
    <div class="infoBoxWrapper">
      <InfoBox
        {latitude}
        {longitude}
        {latLonDirection}
        on:textCopied={textCopiedHandler}
        on:swapButtonClick={swapButtonClickHandler}
      />
    </div>
    <div class="notificationWrapper">
      <Notification {message} />
    </div>
  </div>
</main>

<style>
  .infoBoxWrapper {
    position: absolute;
    top: 10px;
    margin: 0 auto;
    padding: 10px;
    z-index: 900;
    left: 50%;
    transform: translate(-50%, 0);
    background-color: rgba(255, 255, 255, 0.9);
  }
  .notificationWrapper {
    position: absolute;
    bottom: 40px;
    margin: 0 auto;
    padding: 10px;
    z-index: 900;
    right: 10px;
  }
  .titleLine {
    padding: 0 10px;
  }
</style>
